import { useState } from "react";
import AuthLayout from "@/features/auth/components/auth-layout";
import EmailInput from "@/features/auth/components/email-input";
import { Button } from "ui-components/button";
import { useResetPasswordApi } from "@/api/use-reset-password-api";
import { FeedbackAlert } from "ui-components/feedback-alert";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const { resetPassword, isLoading, isError, isSuccess, errorMessage } = useResetPasswordApi();

  const disabled = email === "" || isLoading;
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isLoading) {
      resetPassword({ email });
    }
  };
  const title = isSuccess ? "Password reset link sent!" : "Forgot your password?";
  const description = isSuccess
    ? "If an account exists with this email, you will receive a password reset link shortly."
    : "Enter the email used to register";
  return (
    <AuthLayout title={title} description={description}>
      {isSuccess ? (
        <Button disabled={isLoading} variant="brand" href="/auth/sign-in" className="w-full">
          Back to log in
        </Button>
      ) : (
        <form role="form" onSubmit={handleSubmit} className="flex flex-col  w-full">
          <div className="flex flex-col gap-3 w-full">
            <EmailInput onEmailChange={setEmail} email={email} />
            <Button type="submit" variant="brand" className="w-full" disabled={disabled}>
              Send password reset link
            </Button>
            <Button disabled={isLoading} variant="plain" href="/auth/sign-in" className="w-full">
              Back to log in
            </Button>
          </div>
        </form>
      )}
      {isError && (
        <FeedbackAlert type="error" title="Error" description={errorMessage || "Failed to send password reset link"} />
      )}
    </AuthLayout>
  );
};

export default ForgotPassword;
